/**
 * Created by shuhin on 1/7/2020.
 */
import React, { Component } from 'react';
import Preview from './preview';
import PrescriptionChooser from './prescription-chooser';

class PrescriptionUpload extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      selectedFiles: [],
      fileTypes: new Map(),
      showPreview: false,
    };
  }

  onFilesSelect = (e)=>{
    const selectedFiles = e.target.files;
    this.setState({ selectedFiles, showPreview: true });
  };

  closePreview = ()=>{
    this.setState({showPreview: false});
  };

  onSubmit = (selectedFiles) =>{
    this.setState({showPreview: false});
    this.props.onSubmit(selectedFiles);
  };

  render() {
    const { selectedFiles, showPreview } = this.state;
    const { label= "Select File", showIcon, style } = this.props;
    return (
      <div style={{display:'inline'}}>
        <PrescriptionChooser
          showIcon={showIcon}
          label={label}
          style={style}
          onSelect={this.onFilesSelect}
        />
        <Preview
          selectedFiles={selectedFiles}
          showPreview={showPreview}
          onRequestClose={this.closePreview}
          fileTypes={this.state.fileTypes}
          onSubmit={this.onSubmit}
        />
      </div>
    );
  }
}

export default PrescriptionUpload;


// WEBPACK FOOTER //
// ./src/screens/shared/file-upload/prescription-upload.js